// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__AUsZW","header":"ClearentDisclaimer_header__118Hd","inner":"ClearentDisclaimer_inner__xmH2o"};